import React, { useState } from 'react';
import {
  Box,
  Typography,
  Paper,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from '@mui/material';
import { Group as GroupIcon } from '@mui/icons-material';
import { useData } from '../contexts/DataContext';

export default function Admin() {
  const { userRole, teams, setTeams } = useData();
  const [teamDialogOpen, setTeamDialogOpen] = useState(false);
  const [newTeamName, setNewTeamName] = useState('');

  const handleTeamDialogOpen = () => {
    setTeamDialogOpen(true);
  };

  const handleTeamDialogClose = () => {
    setTeamDialogOpen(false);
    setNewTeamName('');
  };

  const handleCreateTeam = () => {
    if (newTeamName.trim()) {
      setTeams([...teams, { id: Date.now().toString(), name: newTeamName }]);
      handleTeamDialogClose();
    }
  };

  if (userRole !== 'admin') {
    return (
      <Box sx={{ p: 3 }}>
        <Typography variant="h4" gutterBottom>
          Access Denied
        </Typography>
        <Typography>You do not have permission to access this page.</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Admin Panel
      </Typography>

      <Paper sx={{ mt: 3 }}>
        <List>
          <ListItem>
            <ListItemIcon>
              <GroupIcon />
            </ListItemIcon>
            <ListItemText 
              primary="Teams" 
              secondary="Manage your teams"
            />
            <Button variant="outlined" size="small" onClick={handleTeamDialogOpen}>
              Create Team
            </Button>
          </ListItem>
        </List>
      </Paper>

      <Dialog open={teamDialogOpen} onClose={handleTeamDialogClose}>
        <DialogTitle>Create Team</DialogTitle>
        <DialogContent>
          <TextField
            label="Team Name"
            value={newTeamName}
            onChange={(e) => setNewTeamName(e.target.value)}
            fullWidth
            required
            sx={{ mt: 2 }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleTeamDialogClose}>Cancel</Button>
          <Button onClick={handleCreateTeam} variant="contained" color="primary">
            Create
          </Button>
        </DialogActions>
      </Dialog>

      <Paper sx={{ mt: 3 }}>
        <List>
          {teams.map((team) => (
            <ListItem key={team.id}>
              <ListItemText primary={team.name} />
            </ListItem>
          ))}
        </List>
      </Paper>
    </Box>
  );
} 